import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-toastify/dist/ReactToastify.min.css'
import './config/styles.css';

ReactDOM.render(
  <App/>, document.getElementById('root')
);